<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('直播课程.课程')">
                <a-select v-model="queryParam.courseId" allowClear @change="handleCourseChange">
                  <a-select-option v-for="item in courseList" :key="item.id" :value="item.id">
                    {{ item.courseTitle }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('直播课程.章节')">
                <a-select v-model="queryParam.chapterId" allowClear @change="handleQuery">
                  <a-select-option v-for="item in chapterList" :key="item.id" :value="item.id">
                    {{ item.chapterName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="是否推荐">
                <a-select v-model="queryParam.isRecommend" allowClear placeholder="请选择">
                  <a-select-option :value="1">是</a-select-option>
                  <a-select-option :value="0">否</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['livecourse:liveCourseSection:add']">
          <a-icon type="plus" />{{$t('通用.按钮.新增')}}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['livecourse:liveCourseSection:remove']">
          <a-icon type="delete" />{{$t('通用.按钮.删除')}}
        </a-button>
      </div>
      <!-- 增加修改 -->
      <create-form ref="createForm" :courseList="courseList" @ok="getList" />
      <a-table
        :loading="loading"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="scheduledStartTime" slot-scope="text, record">
          {{ parseTime(record.scheduledStartTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="isRecommend" slot-scope="text, record">
          <a-tag v-if="record.isRecommend === 1" color="green">是</a-tag>
          <a-tag v-else color="default">否</a-tag>
        </span>
        <span slot="liveStatus" slot-scope="text, record">
          <a-tag v-if="record.liveStatus === 1" color="blue">未开播</a-tag>
          <a-tag v-else-if="record.liveStatus === 2" color="green">直播中</a-tag>
          <a-tag v-else-if="record.liveStatus === 3" color="red">已结束</a-tag>
          <span v-else>-</span>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record)" v-hasPermi="['livecourse:liveCourseSection:edit']">
            <a-icon type="edit" />{{$t('通用.按钮.修改')}}
          </a>
          <a-divider type="vertical" />
          <a @click="handleReplayManage(record)" v-hasPermi="['livecourse:liveCourseSectionReplay:page']">
            <a-icon type="video-camera" />回放管理
          </a>
          <a-divider type="vertical" />
          <a @click="handleCreateLive(record)" v-if="!record.liveId" v-hasPermi="['livecourse:liveCourseSection:createLive']">
            <a-icon type="video-camera" />创建直播间
          </a>
          <template v-if="record.liveId">
            <a-divider type="vertical" />
            <a @click="handleStartLive(record)" v-if="record.liveStatus === 1 || record.liveStatus === 3" v-hasPermi="['livecourse:liveCourseSection:startLive']">
              <a-icon type="play-circle" />开启直播
            </a>
            <a-divider type="vertical" v-if="record.liveStatus === 1" />
            <a @click="handleEndLive(record)" v-if="record.liveStatus === 1 || record.liveStatus === 2" v-hasPermi="['livecourse:liveCourseSection:endLive']">
              <a-icon type="stop" />关闭直播
            </a>
            <a-divider type="vertical" v-if="record.liveStatus === 2" />
            <a @click="handleShowLiveInfo(record)" v-hasPermi="['livecourse:liveCourseSection:getLiveInfo']">
              <a-icon type="link" />直播地址
            </a>
          </template>
          <a-divider type="vertical" />
          <a @click="handleDelete(record)" v-hasPermi="['livecourse:liveCourseSection:remove']">
            <a-icon type="delete" />{{$t('通用.按钮.删除')}}
          </a>
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
    <!-- 直播地址弹窗 -->
    <a-modal
      title="直播地址信息"
      :visible="liveInfoVisible"
      :footer="null"
      @cancel="liveInfoVisible = false"
      width="600px"
    >
      <a-descriptions :column="1" bordered>
        <a-descriptions-item label="直播间主题">
          {{ liveInfo.theme }}
        </a-descriptions-item>
        <a-descriptions-item label="封面图">
          <img v-if="liveInfo.thumb" :src="liveInfo.thumb" style="max-width: 200px; max-height: 150px;" />
          <span v-else>暂无封面</span>
        </a-descriptions-item>
        <a-descriptions-item label="OBS推流地址">
          <a-typography-paragraph copyable>
            {{ liveInfo.obsPushUrl }}
          </a-typography-paragraph>
        </a-descriptions-item>
        <a-descriptions-item label="推流码">
          <a-typography-paragraph copyable>
            {{ liveInfo.obsPushCode }}
          </a-typography-paragraph>
        </a-descriptions-item>
        <a-descriptions-item label="拉流地址(HLS)">
          <a-typography-paragraph copyable>
            {{ liveInfo.pullUrlHls }}
          </a-typography-paragraph>
        </a-descriptions-item>
      </a-descriptions>
    </a-modal>
    <!-- 回放管理弹窗 -->
    <replay-modal ref="replayModal" />
  </page-header-wrapper>
</template>

<script>
import { pageLiveCourseSection, delLiveCourseSection, createLive, startLive, endLive, getLiveInfo } from '@/api/livecourse/liveCourseSection'
import { listLiveCourse } from '@/api/livecourse/liveCourse'
import { listLiveCourseChapter } from '@/api/livecourse/liveCourseChapter'
import CreateForm from './modules/CreateForm'
import ReplayModal from './modules/ReplayModal'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'LiveCourseSection',
  components: {
    CreateForm,
    ReplayModal
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      courseList: [],
      chapterList: [],
      loading: false,
      total: 0,
      selectedRowKeys: [],
      multiple: true,
      queryParam: {
        courseId: undefined,
        chapterId: undefined,
        isRecommend: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        { title: this.$t('直播课程.课程'), dataIndex: 'courseId', customRender: (text, record) => this.getCourseName(record.courseId) },
        { title: this.$t('直播课程.章节'), dataIndex: 'chapterId', customRender: (text, record) => this.getChapterName(record.chapterId) },
        { title: this.$t('直播课程.小节数'), dataIndex: 'sectionNumber' },
        { title: this.$t('直播课程.小节名称'), dataIndex: 'sectionName' },
        { title: '排序序号', dataIndex: 'sort' },
        { title: '是否推荐', dataIndex: 'isRecommend', scopedSlots: { customRender: 'isRecommend' } },
        { title: '直播状态', dataIndex: 'liveStatus', scopedSlots: { customRender: 'liveStatus' } },
        { title: this.$t('直播课程.报名预约数'), dataIndex: 'appointmentCount' },
        { title: this.$t('直播课程.预计开播时间'), dataIndex: 'scheduledStartTime', scopedSlots: { customRender: 'scheduledStartTime' } },
        { title: this.$t('直播课程.创建时间'), dataIndex: 'createTime', scopedSlots: { customRender: 'createTime' } },
        { title: this.$t('通用.文本.操作'), dataIndex: 'operation', scopedSlots: { customRender: 'operation' }, width: 350 }
      ],
      liveInfoVisible: false,
      liveInfo: {}
    }
  },
  created() {
    this.getCourseList()
    this.getList()
  },
  methods: {
    getCourseList() {
      listLiveCourse({}).then(response => {
        this.courseList = response.data
      })
    },
    getCourseName(courseId) {
      const course = this.courseList.find(item => item.id === courseId)
      return course ? course.courseTitle : ''
    },
    getChapterName(chapterId) {
      const chapter = this.chapterList.find(item => item.id === chapterId)
      return chapter ? chapter.chapterName : ''
    },
    handleCourseChange(courseId) {
      this.queryParam.chapterId = undefined
      this.chapterList = []
      if (courseId) {
        listLiveCourseChapter({ courseId }).then(response => {
          this.chapterList = response.data
        })
      }
      this.handleQuery()
    },
    getList() {
      this.loading = true
      pageLiveCourseSection(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
        this.loadChaptersForList()
      })
    },
    loadChaptersForList() {
      const courseIds = [...new Set(this.list.map(item => item.courseId).filter(id => id))]
      courseIds.forEach(courseId => {
        if (!this.chapterList.some(item => item.courseId === courseId)) {
          listLiveCourseChapter({ courseId }).then(response => {
            const chapters = response.data || []
            chapters.forEach(chapter => {
              if (!this.chapterList.some(item => item.id === chapter.id)) {
                this.chapterList.push(chapter)
              }
            })
          })
        }
      })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = { courseId: undefined, chapterId: undefined, isRecommend: undefined, pageNum: 1, pageSize: 10 }
      this.chapterList = []
      this.handleQuery()
    },
    handleDelete(row) {
      const that = this
      this.$confirm({
        title: this.$t('通用.文本.确认删除'),
        content: this.$t('通用.文本.删除确认数据'),
        onOk() {
          const ids = row.id || that.selectedRowKeys
          delLiveCourseSection(Array.isArray(ids) ? ids.map(id => ({ id })) : [{ id: ids }]).then(() => {
            that.getList()
            that.$message.success(that.$t('通用.文本.删除成功'))
          })
        }
      })
    },
    handleCreateLive(row) {
      const that = this
      this.$confirm({
        title: '创建直播间',
        content: '确认要为该小节创建直播间吗？',
        onOk() {
          createLive({ id: row.id }).then(response => {
            if (response.code === '20001') {
              that.$message.success('创建直播间成功')
              that.getList()
            } else {
              that.$message.error(response.msg || '创建直播间失败')
            }
          })
        }
      })
    },
    handleStartLive(row) {
      const that = this
      this.$confirm({
        title: '开启直播',
        content: '确认要开启直播吗？',
        onOk() {
          startLive({ id: row.id }).then(response => {
            if (response.code === '20001') {
              that.$message.success('开启直播成功')
              that.getList()
            } else {
              that.$message.error(response.msg || '开启直播失败')
            }
          })
        }
      })
    },
    handleEndLive(row) {
      const that = this
      this.$confirm({
        title: '关闭直播',
        content: '确认要关闭直播吗？',
        onOk() {
          endLive({ id: row.id }).then(response => {
            if (response.code === '20001') {
              that.$message.success('关闭直播成功')
              that.getList()
            } else {
              that.$message.error(response.msg || '关闭直播失败')
            }
          })
        }
      })
    },
    handleShowLiveInfo(row) {
      getLiveInfo({ id: row.id }).then(response => {
        if (response.code === '20001') {
          this.liveInfo = response.data
          this.liveInfoVisible = true
        } else {
          this.$message.error(response.msg || '获取直播信息失败')
        }
      })
    },
    handleReplayManage(row) {
      this.$refs.replayModal.show(row.id, row.sectionName, row.liveId)
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
      this.multiple = !selectedRowKeys.length
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    }
  }
}
</script>
